import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image, pdf } from '@react-pdf/renderer';
import logoAgs from '../../assets/logo-ags.png';
import logoZonaSur from '../../assets/zonaSur_logo.png';

const styles = StyleSheet.create({
  page: {
    backgroundColor: '#ffffff',
    fontFamily: 'Times-Roman',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
  },
  contentContainer: {
    paddingLeft: '0.75in',
    paddingRight: '0.75in',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  headerAccent: {
    height: '8px',
    width: '100%',
    backgroundColor: '#002542',
  },
  footerAccent: {
    height: '8px',
    width: '100%',
    backgroundColor: '#00a941',
    marginTop: '10px',
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: '20px',
  },
  bodyContainer: {
    flex: 1,
  },
  leftHeader: {
    width: '40%',
  },
  rightHeader: {
    width: '40%',
    textAlign: 'right',
  },
  contactText: {
    fontSize: '12px',
    color: '#666666',
    marginBottom: '3px',
  },
  websiteText: {
    fontSize: '12px',
    fontWeight: 'semibold',
    color: '#00a941',
    marginBottom: '3px',
  },
  dateBadge: {
    backgroundColor: '#002542',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: 'medium',
    textAlign: 'right',
  },
  bodyText: {
    fontSize: '10px',
    color: '#333333',
    lineHeight: 1.5,
    marginBottom: '15px',
    textAlign: 'justify',
  },
  etapasList: {
    marginBottom: '15px',
  },
  etapaText: {
    fontSize: '10px',
    color: '#333333',
    lineHeight: 1.5,
    marginBottom: '5px',
  },
  salutation: {
    fontSize: '10px',
    color: '#002542',
    marginBottom: '15px',
  },
  closing: {
    fontSize: '10px',
    color: '#002542',
    marginBottom: '10px',
  },
  signatureContainer: {
    position: 'relative',
    width: '320px',
    padding: '10px',
  },
  signatureAccent: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#002542',
    opacity: 0.05,
    borderRadius: '12px',
    zIndex: -1,
  },
  signatureName: {
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#002542',
    marginBottom: '5px',
  },
  signatureTitle: {
    fontSize: '10px',
    fontStyle: 'italic',
    fontWeight: 'medium',
    color: '#00a941',
    marginBottom: '5px',
  },
  signatureContact: {
    fontSize: '8px',
    color: '#666666',
  },
});

const JustificanteEscolar = ({ alumno, etapas, gira, nombre, firma, titulo, fecha = new Date().toLocaleDateString('es-MX') }) => {
  const MyDocument = () => (
    <Document>
      <Page size="LETTER" style={styles.page}>
        {/* Header accent bar */}
        <View style={styles.headerAccent} />

        {/* Content Container */}
        <View style={styles.contentContainer}>
          {/* Header with left and right sections */}
          <View style={styles.headerContainer}>
            <View style={styles.leftHeader}>
              <Image
                src={logoAgs}
                style={{ width: '100px', height: 'auto', marginBottom: '5px', marginTop: '35px' }}
              />
            </View>

            <View style={styles.rightHeader}>
              <Image
                src={logoZonaSur}
                style={{ width: '100px', height: 'auto', marginLeft: 'auto' }}
              />
              <Text style={styles.contactText}>Email: info@golfsur.com</Text>
              <Text style={styles.websiteText}>www.golfsur.com.mx</Text>
              <View style={[styles.dateBadge, { width: '80px', marginLeft: 'auto' }]}>
                <Text>{fecha}</Text>
              </View>
            </View>
          </View>

          {/* Letter Body */}
          <View style={styles.bodyContainer}>
            <Text style={styles.salutation}>A quien corresponda,</Text>
            
            <Text style={styles.bodyText}>
              Por medio de la presente le solicito de la manera más atenta, tenga a bien otorgar el permiso al alumno(a) {' '}
              <Text style={{ fontWeight: 'bold' }}>{alumno}</Text>{' '} para faltar al colegio y/o clases en línea durante los días en que tendrán participación en la{' '}
              <Text style={{ fontWeight: 'bold' }}>{gira}</Text>{' '}
              de nuestra Asociación de Golf del Sur A.C., los siguientes días de torneo con un día previo para práctica y/o traslado según sede.
            </Text>

            <Text style={styles.bodyText}>Etapas:</Text>
            <View style={styles.etapasList}>
              {etapas.map((etapa, index) => (
                <Text key={index} style={styles.etapaText}>• {etapa}</Text>
              ))}
            </View>

            <Text style={styles.bodyText}>
              Esperando le justifiquen las faltas y solicitamos igualmente que las situaciones que se puedan presentar como entregas de trabajos, tareas y exámenes se le puedan adelantar o reasignar en otras fechas con el fin de apoyar su desarrollo deportivo a{' '}
              <Text style={{ fontWeight: 'bold' }}>{alumno}</Text>{' '}.
            </Text>
            
            <Text style={styles.bodyText}>
              Sin más por el momento y esperando contar con su invaluable apoyo le envió un cordial saludo y mi más sincero agradecimiento.
            </Text>
            {/* Closing */}
            <Text style={styles.closing}>Atentamente,</Text>
          </View>

          {/* Signature Section */}
          <View style={styles.signatureContainer}>
            <View style={styles.signatureAccent} />
            {firma && (
              <Image 
                src={firma} 
                style={{ width: '300px', height: '100px', marginBottom: '10px' }} 
              />
            )}
            <Text style={styles.signatureName}>{nombre}</Text>
            <Text style={styles.signatureTitle}>{titulo}</Text>
            <Text style={styles.signatureContact}>Asociación de Golf del Sur A.C.</Text>
          </View>
        </View>

        {/* Footer accent bar */}
        <View style={styles.footerAccent} />
      </Page>
    </Document>
  );

  // Generate PDF and return blob
  const generatePDF = async () => {
    const pdfBlob = await pdf(<MyDocument />).toBlob();
    return pdfBlob;
  };

  return generatePDF();
};

export default JustificanteEscolar;